// extracted by mini-css-extract-plugin
export default {"inputText":"SubCategories_inputText__TrTmA"};